import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What does a web designer do?",
    answer: `<p>
      Web designers are responsible for planning, building, and
      coding websites and their pages. They combine text, images,
      videos, and graphics to create visuals that are aligned with
      the brand. Their job description also includes creating
      entire layouts, working on improving the orientation of an
      existing website or creating a web design from scratch.
    </p>`,
  },
  {
    question: " How much does it cost to hire someone to build a website?",
    answer: `<p>
      The average cost of building a website is between $200 to
      $500. For sophisticated websites with advanced
      functionality, the price mentioned earlier may vary. In
      fact, some websites depending on their features and
      functionality can cost you from $20,000 to $40,000 keeping
      the budget for the domain name and hosting aside.
    </p>`,
  },
  {
    question: " What is meant by web development?",
    answer: `<p>
      Web development is the process of developing websites for
      the world wide web, internet, or intranet. Web developers
      create complex functionality of websites like forms, CTAs,
      codes, and other important non-design aspects.
    </p>`,
  },
  {
    question: " What does a web development agency do?",
    answer: `<p>
      A web development agency is responsible for building
      websites for entrepreneurs, SMEs, and enterprise-level
      organizations. A web development agency also develops the
      sophisticated functionality of a website and brings the
      desired purpose of the website to life.
    </p>`,
  },
  {
    question: "How do I choose a web development agency?",
    answer: `<p>
    Due to the abundance of web development agencies operating
    in the market today, selecting the best one out of them can
    be a daunting task. However, with the right approach, you
    can select the best web development agency for your project.
    Here’s a glimpse of the right approach.
  </p> 
  <ul>
  <li>Go through the company’s portfolio</li>
  <li>
    See what their existing clients have to say about them.
  </li>
  <li>Ask for references.</li>
  <li>
    Read their reviews on credible platforms such as Clutch or
    GoodFirms.
  </li>
  <li>Evaluate the quality of their own website.</li>
  <li>
    See how fast the company is responding to your emails.
  </li>
</ul>`,
  },
  {
    question: "  How do I hire a web development company?",
    answer: `<p>
  There are several ways of hiring a web development company.
  However, it depends on the type of hiring model that you
  prefer. For example, if you’re in search of a freelance web
  developer, you can hire them through freelancing platforms
  such as Upwork or Fiver.Similarly, if you’re looking to hire
  a web development company, you can simply search on Google.
  Streamline the best among the many web development
  companies. Follow the approach mentioned above and choose
  the best agency for your project.
</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
